module.exports = {"id":"dp3_4l3q3","text":"Computational Thinking and Programming","instructions":"Which problem is generally considered computable?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.4","questionType":"PickOne","random":true,"options":[{"id":"dp3_4l3q3-a1","text":"Sorting a list of numbers using defined rules","score":3.7},{"id":"dp3_4l3q3-a2","text":"Determining absolute moral correctness universally","score":1.3},{"id":"dp3_4l3q3-a3","text":"Predicting every future human decision","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.4/l3q3.json
// module id = 1182
// module chunks = 41